import React from 'react'
import { css } from '@emotion/core'
import { Button, Paragraph, Separator } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import Tip from '../../../../../../components/tip/Tip'
import SplitScreenToggle from '../../../fieldComponents/SplitScreenToggleButton/SplitScreenToggle'
import { useOverlayContext } from '../../../../../../../shared/providers/overlayContextProvider/OverlayContext'
import HelpOverlayLearnMore from '../../../../../../components/sharedHelp/HelpOverlayLearnMore'

const RelationshipTips = () => {
  const { openOverlay } = useOverlayContext()
  const helpActionUrl =
    'https://www.familysearch.org/en/help/helpcenter/article/what-is-the-difference-between-a-record-and-an-image'
  const [t] = useTranslation()

  const listStyle = css`
    list-style-type: disc;
  `

  return (
    <Tip
      primaryText={t('edit-relationships.tip', 'Help with Relationships')}
      listPrimaryText={
        <>
          <span>
            <b>{t('edit-relationships.tip-1-overline', '1. How to move names to the correct record group.')}</b>
          </span>
          <Paragraph size="sm">
            {t(
              'edit-relationships.tip-1-primary',
              'Use the Drag Names tool to move names that belong in other records.'
            )}
          </Paragraph>
          <HelpOverlayLearnMore helpActionUrl={helpActionUrl} />
          <Button onClick={() => openOverlay('dragNames')}>{t('edit-relationships.drag-names', 'Drag Names')}</Button>

          <Separator size="sm" />

          <span>
            <b>{t('edit-relationships.tip-2-overline', '2. How to change the spelling of a name.')}</b>
          </span>
          <ul css={listStyle}>
            <li>{t('edit-relationships.tip-2-step-1', 'Find the name you would like to correct.')}</li>
            <li>{t('edit-relationships.tip-2-step-2', 'Below the name, click the Edit button.')}</li>
            <li>
              {t('edit-relationships.tip-2-step-3', 'Go to the Essential Information section and edit the name.')}
            </li>
          </ul>

          <Separator size="sm" />

          <span>
            <b>{t('edit-relationships.tip-3-overline', '3. Is the information on another page?')}</b>
          </span>
          <Paragraph size="sm">
            {t(
              'edit-relationships.tip-3-primary',
              'If the information is on another page, try entering split-screen mode.'
            )}
          </Paragraph>
          <SplitScreenToggle />

          <Separator size="sm" />

          <span>
            <b>{t('edit-relationships.tip-4-overline', '4. How to add a new name')}</b>
          </span>
          <ul css={listStyle}>
            <li>{t('edit-relationships.tip-4-step-1', 'Create a new relationship.')}</li>
            <li data-testid="list-item-type-a-name">
              {t(
                'edit-relationships.tip-4-step-2',
                'Start typing in a name. If the name doesn’t exist in the surrounding pages, select Name Not Indexed.'
              )}
            </li>
            <li>{t('edit-relationships.tip-4-step-3', 'Create the new person and save.')}</li>
          </ul>
        </>
      }
    />
  )
}

export default RelationshipTips
